import { OptionsValues } from '@smartera/core';

export interface SearchFilters {
	[key: string]: SearchFilter;
}

export interface SearchFilter {
	field: string;
	operator: FilterOperator;
	firstSearchPart: string | Date | number | string[] | OptionsValues;
	lastSearchPart: string | Date | number;
}

export type FilterOperator = 'match' | 'range' | 'term' | 'dynamic' | 'indicator-date';

export interface DateFilterQuery {
	range: {
		[key: string]: DateFilter;
	};
}

export interface DateFilter {
	gte?: string | Date;
	lte?: string | Date;
	gt?: string | Date;
	lt?: string | Date;
	format?: string;
}

export interface TextFilterTermsQuery {
	terms: {
		[key: string]: string;
	};
}

export interface TextFilterMatchQuery {
	query_string: {
		query: string;
		fields: string[];
		default_operator: 'AND' | 'OR';
	};
}

export interface NumberFilterTermsQuery {
	terms: {
		[key: string]: number[];
	};
}

export interface NumberFilterRangeQuery {
	range: {
		[key: string]: {
			gte: number;
			lte: number;
		};
	};
}

export type FilterQuery = Array<
	DateFilterQuery | NumberFilterRangeQuery | NumberFilterTermsQuery | TextFilterMatchQuery | TextFilterTermsQuery
>;

export const TextFieldFilterOptions: OptionsValues = [
	{ label: 'filter-report.contain', value: 'match', type: 'report' },
	{ label: 'filter-report.exact-match', value: 'term' },
];

export const NumberFieldFilterOptions: OptionsValues = [
	{ label: 'filter-report.exact-match', value: 'term', type: 'report' },
	{ label: 'filter-report.range', value: 'range' },
];

export const DateFieldFilterOptions: OptionsValues = [
	{ label: 'filter-report.exact-match', value: 'term', type: 'report' },
	{ label: 'filter-report.range', value: 'range' },
	{ label: 'filter-report.dynamic', value: 'dynamic', type: 'report' },
	{ label: 'filter-report.indicator-date', value: 'indicator-date', disabled: false, type: 'report' },
];

export const IndicatorDateOptions: OptionsValues = [
	{ label: 'unselected', value: null },
	{ label: 'filter-report.indicator-dates.today', value: 'Today' },
	{ label: 'filter-report.indicator-dates.this-week', value: 'BeginningOfCurrentWeek' },
	{
		label: 'filter-report.indicator-dates.this-month',
		value: 'BeginningOfCurrentMonth',
	},
	{
		label: 'filter-report.indicator-dates.this-year',
		value: 'BeginningOfCurrentYear',
	},
];
